import { render } from "./CompletarCadastroPJ.vue?vue&type=template&id=31551488&scoped=true"
import script from "./CompletarCadastroPJ.vue?vue&type=script&lang=js"
export * from "./CompletarCadastroPJ.vue?vue&type=script&lang=js"

import "./CompletarCadastroPJ.vue?vue&type=style&index=0&id=31551488&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31551488"]])

export default __exports__